export enum RateNameEnum {
  LIVE_RATE = "Live Rate",
  EXPRESS_RATE = "Express",
  CONTRACT_RATE = "Contract Rate",
  MARKET_RATE = "Market Rate",
  ESTIMATED_RATE = "Estimated",
}
